module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BlackItalic-WebM-5d983f28e9eec7aa0b450fb29d760839.woff2";